export default __webpack_public_path__ + "assets/static/data/app.model.957841816343ffb4e26813ebe3311ca6.json";